<template>
  <div class="app-top">
    <div class="app-top-right">
      <ul>
        <router-link :to="item.routerName"
          tag="li"
          v-for="(item, index) in tabs"
          :key="item.id"
          :class="i == index ? 'll' : ''"
        >

            <div :class="i == index ? 'cl' : ''">
            {{ item.title }}</div>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  inject:['reload'],
  name: "HomeTop",
  props: ["i"],
  data() {
    return {
      detail: {},
      tabs: [
        // {id:1,title:'首页',routerName:{name:'HelloWorld'}},
        // {id:2,title:'酒店',routerName:{name:'Hotel'}},
        // {id:3,title:'旅游',routerName:{name:'Travel'}},
        // {id:4,title:'用车',routerName:{name:'Car'}},
        // {id:5,title:'门票',routerName:{name:'Tips'}},
        // {id:6,title:'攻略',routerName:{name:'Method'}},
        // {id:7,title:'购物',routerName:{name:'Shopping'}},
        // {id:8,title:'目的地',routerName:{name:'Destination'}},
        // {id:9,title:'服务',routerName:{name:'Service'}},
        // {id:10,title:'更多',routerName:{name:'More'}},
        { id: 1, title: "首页", routerName: { name: "HelloWorld" } },
        { id: 2, title: "酒店", routerName: { name: "hotel" } },
        { id: 3, title: "旅游", routerName: { name: "travel" } },
        { id: 4, title: "用车", routerName: { name: "Car" } },
        { id: 5, title: "景区", routerName: { name: "scenic" } },
        { id: 6, title: "攻略", routerName: { name: "strategyHome" } },
        { id: 7, title: "购物", routerName: { name: "shopping" } },
        // { id: 8, title: "目的地", routerName: { name: "" } },
        { id: 9, title: "定制旅游", routerName: { name: "make" } },
        // { id: 10, title: "更多", routerName: { name: "" } },
      ],
    };
  },
  watch:{
    $route(to,from){
      console.log(to.path)
      if(to.path=='/car/BanChe/cheDan'||to.path=='/BanCar/banDan'){
        /* this.$router.go(0) */
        this.reload()
      }
    }
  },
  methods: {},
  created() {
    // this.$axios.get('pc/pc_phone')
    //   .then(res=>{
    //      console.log(res)
    //      if(res.data.code==200){
    //       this.detail=res.data.phone
    //      }
    //   })
    //   .catch(err=>{
    //     console.log('获取失败')
    //   })
  },
};
</script>

<style scoped>
.app-top {
  width: 100%;
  height: 56px;
  text-align: center;
  display: flex;
}
.app-top-left {
  width: 30%;
  height: 58px;
  padding: 20px 0% 20px 10%;
  display: flex;
}
.app-top-left img {
  width: 62px;
  height: 41px;
}
.app-top-text {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.app-top-txt {
  font-size: 18px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  text-transform: uppercase;
}
.app-top-right {
  width: 70%;
  height: 56px;
  background: linear-gradient(
    90deg,
    rgba(0, 180, 255, 1),
    rgba(16, 218, 255, 1)
  );
  padding: 0 15%;
}
ul {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
li {
  flex: 1;
  list-style: none;
  float: left;
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  height: 56px;
  line-height: 56px;
  text-align: center;

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}
li:hover {
  background: rgba(0, 162, 255, 0.3);
}
a {
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
}
.cl {
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
  transition: all 0.3s ease;
}
.ll {
  background: rgba(0, 162, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/homeTop/homeTop.vue